export type WifiPlatform = 'iphone' | 'android' | 'mac' | 'windows'

interface NavigatorLike {
  userAgent?: string
  maxTouchPoints?: number
  userAgentData?: { platform?: string; mobile?: boolean }
}

/** Picks the setup tab that matches the device the page is opened on. */
export function detectPlatform(nav: NavigatorLike = navigator): WifiPlatform {
  const ua = nav.userAgent ?? ''
  const uaPlatform = nav.userAgentData?.platform ?? ''
  const mobile = nav.userAgentData?.mobile ?? /Mobi/i.test(ua)

  if (/iPhone|iPad|iPod/i.test(ua) || uaPlatform === 'iOS') return 'iphone'
  if (/Android/i.test(ua) || uaPlatform === 'Android') return 'android'
  // iPadOS 13+ reports a Macintosh user agent but has a touch screen.
  if (/Macintosh|Mac OS X/i.test(ua) || uaPlatform === 'macOS') {
    return (nav.maxTouchPoints ?? 0) > 1 ? 'iphone' : 'mac'
  }
  if (/Windows/i.test(ua) || uaPlatform === 'Windows') return 'windows'
  // Chromebooks and Linux desktops use the Android-style EAP settings.
  if (/CrOS|Linux/i.test(ua) || uaPlatform === 'Chrome OS' || uaPlatform === 'Linux')
    return 'android'
  return mobile ? 'iphone' : 'windows'
}
